/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_home_round = /** @type {(inputs: { round: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Round ${i?.round}`)
};

const es_f1_home_round = /** @type {(inputs: { round: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ronda ${i?.round}`)
};

const de_f1_home_round = /** @type {(inputs: { round: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Runde ${i?.round}`)
};

const nl_f1_home_round = /** @type {(inputs: { round: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ronde ${i?.round}`)
};

const fr_f1_home_round = /** @type {(inputs: { round: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Manche ${i?.round}`)
};

const it_f1_home_round = /** @type {(inputs: { round: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Round ${i?.round}`)
};

const pt_br2_f1_home_round = /** @type {(inputs: { round: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rodada ${i?.round}`)
};

const pt_f1_home_round = /** @type {(inputs: { round: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ronda ${i?.round}`)
};

const ja_f1_home_round = /** @type {(inputs: { round: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ラウンド ${i?.round}`)
};

const zh_f1_home_round = /** @type {(inputs: { round: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第${i?.round}轮`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ round: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_home_round = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_home_round(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_home_round", locale)
	if (locale === "en") return en_f1_home_round(inputs)
	if (locale === "es") return es_f1_home_round(inputs)
	if (locale === "de") return de_f1_home_round(inputs)
	if (locale === "nl") return nl_f1_home_round(inputs)
	if (locale === "fr") return fr_f1_home_round(inputs)
	if (locale === "it") return it_f1_home_round(inputs)
	if (locale === "pt-BR") return pt_br2_f1_home_round(inputs)
	if (locale === "pt") return pt_f1_home_round(inputs)
	if (locale === "ja") return ja_f1_home_round(inputs)
	return zh_f1_home_round(inputs)
};